import { degrees, PDFDocument, PDFFont, PDFPage, StandardFonts } from "pdf-lib";

export class PdfManipulation {
  static async writeGetDepseudonimisiertesPdf(pdf: Blob, betriebsbezeichnung: string) {
    // Load a PDFDocument from the existing PDF bytes
    const pdfDoc: PDFDocument = await PDFDocument.load(
      await new Response(pdf).arrayBuffer()
    );

    // Embed the Helvetica font
    const helveticaFont: PDFFont = await pdfDoc.embedFont(
      StandardFonts.Helvetica
    );

    // Get the first page of the document
    const pages: PDFPage[] = pdfDoc.getPages();
    const firstPage: PDFPage = pages[0];

    // Get the width and height of the first page
    const { width, height } = firstPage.getSize();

    // Draw a string of text diagonally across the first page
    const text = (betriebsbezeichnung ?? "").trim();

    firstPage.drawText(text, {
      x: width - 362,
      y: height - 627,
      size: 10,
      font: helveticaFont,
      rotate: degrees(90),
    });

    // Serialize the PDFDocument to bytes (a Uint8Array)
    return pdfDoc.save();
  }
}
